/**
 * GeneralMeetingTypeTag Component
 * Simplified meeting type badge that collapses to a binary individual/group distinction.
 * For use in new hire, manager, and buddy contexts where the adhoc/recurring distinction
 * is not relevant.
 */

import { Badge } from "@chakra-ui/react";
import { MeetingTypeInput } from "design-system/components/AdminMeetingTypeTag";

const GROUP_TYPES: MeetingTypeInput[] = [
  "group_session_adhoc",
  "group_session_recurring",
  "group_session",
  "recurring",
];

interface GeneralMeetingTypeTagProps {
  meetingType: MeetingTypeInput;
}

export function GeneralMeetingTypeTag({ meetingType }: GeneralMeetingTypeTagProps) {
  const isGroup = (GROUP_TYPES as string[]).includes(meetingType);
  return (
    <Badge
      variant="subtle"
      colorScheme={isGroup ? "purple" : "blue"}
      fontSize="2xs"
      fontWeight="500"
      textTransform="none"
      flexShrink={0}
      borderRadius="sm"
      px={1.5}
      py={0.5}
    >
      {isGroup ? "Group Meeting" : "Individual Meeting"}
    </Badge>
  );
}
